import _sortBy from 'lodash/sortBy';
import { connect } from 'react-redux';
import ChatMenuModal from '../../components/modals/chatmenu';
const mapStateToProps = (_state, ownProps) => {
    var _a;
    let payload = {
        buttons: [
            {
                button: '',
                nodeId: '',
            },
        ],
        text: '',
    };
    if ((_a = ownProps.node.payload) === null || _a === void 0 ? void 0 : _a.buttons) {
        payload = {
            buttons: [],
            text: ownProps.node.payload.text,
        };
        payload.buttons = _sortBy(ownProps.node.payload.buttons, 'order');
    }
    return {
        payload,
        initialValues: payload,
    };
};
export default connect(mapStateToProps)(ChatMenuModal);
